import { isArrayLikeObject, isArrayLike, map, isEmpty, filter, includes, join } from 'lodash';
import OptionsSelectionResolutionModel from 'commons-vehicle/ModelYear/models/OptionsSelectionResolutionModel.js';

import * as OptionService from 'commons-vehicle/ModelYear/services/OptionService/OptionService.js';

import { ITEM_FLAG, DATA_TYPES } from 'commons-vehicle/constants/dataTypes.js';
/* eslint no-bitwise: 0 */

const { FEATURE } = DATA_TYPES;

export function resetResolutionOptionsFromResolutionData(
    resolution,
    configurationOptionsSelectionCodes,
    originalOptionsSelectionCodes,
    triggerSelectionCode
) {
    const optionsSelectionResolution = new OptionsSelectionResolutionModel();
    if (
        isEmpty(resolution) ||
        !isArrayLikeObject(resolution.items) ||
        !isArrayLike(configurationOptionsSelectionCodes) ||
        !isArrayLike(originalOptionsSelectionCodes)
    ) {
        return optionsSelectionResolution;
    }

    const options = map(resolution.items, (option) => {
        return OptionService.resetOptionFromOptionData(option);
    });

    const nonDefaultOptions = filter(options, (option) => {
        return !includes(configurationOptionsSelectionCodes, option.selectionCode);
    });

    const newlyAddedOptions = filter(nonDefaultOptions, (option) => {
        return option.selected && !includes(originalOptionsSelectionCodes, option.selectionCode);
    });
    const newlyAddedOptionsSelectionCodes = map(newlyAddedOptions, (newlyAddedOption) => {
        return newlyAddedOption.selectionCode;
    });

    const newlyRemovedOptions = filter(nonDefaultOptions, (option) => {
        return !option.selected && includes(originalOptionsSelectionCodes, option.selectionCode);
    });
    const newlyRemovedOptionsSelectionCodes = map(newlyRemovedOptions, (newlyRemovedOption) => {
        return newlyRemovedOption.selectionCode;
    });

    const resolvedOptionsSelectionCodes = map(resolution.resolvedItems, (option) => {
        return option.item;
    });
    const actionOptions = filter(nonDefaultOptions, (nonDefaultOption) => {
        return includes(resolvedOptionsSelectionCodes, nonDefaultOption.selectionCode);
    });

    const addedCodes = join(
        map(newlyAddedOptions, (newlyAddedOption) => {
            return newlyAddedOption.selectionCode;
        }),
        '|'
    );
    const removedCodes = join(
        map(newlyRemovedOptions, (newlyRemovedOption) => {
            return newlyRemovedOption.selectionCode;
        }),
        '|'
    );

    const isCancel =
        (newlyAddedOptionsSelectionCodes.length === 1 &&
            includes(newlyAddedOptionsSelectionCodes, triggerSelectionCode)) ||
        (newlyRemovedOptionsSelectionCodes.length === 1 &&
            includes(newlyRemovedOptionsSelectionCodes, triggerSelectionCode));

    let id = '';
    if (addedCodes || removedCodes) {
        id = `A${addedCodes}-R${removedCodes}`;
    }

    const exteriorColourOptions = filter(newlyRemovedOptions, (option) => {
        return option.dataType === FEATURE.DATA_TYPE_ID && option.typeID === FEATURE.TYPES.EXTERIOR_COLOUR;
    });
    let availableExteriorColours = [];
    if (!isEmpty(exteriorColourOptions)) {
        availableExteriorColours = filter(nonDefaultOptions, (option) => {
            return (
                option.dataType === FEATURE.DATA_TYPE_ID &&
                option.typeID === FEATURE.TYPES.EXTERIOR_COLOUR &&
                (option.flag & ITEM_FLAG.AVAILABLE) === ITEM_FLAG.AVAILABLE
            );
        });
    }

    const interiorColourOptions = filter(newlyRemovedOptions, (option) => {
        return option.dataType === FEATURE.DATA_TYPE_ID && option.typeID === FEATURE.TYPES.INTERIOR_TRIM;
    });
    let availableInteriorColours = [];
    if (!isEmpty(interiorColourOptions)) {
        availableInteriorColours = filter(nonDefaultOptions, (option) => {
            return (
                option.dataType === FEATURE.DATA_TYPE_ID &&
                option.typeID === FEATURE.TYPES.INTERIOR_TRIM &&
                (option.flag & ITEM_FLAG.AVAILABLE) === ITEM_FLAG.AVAILABLE
            );
        });
    }

    return optionsSelectionResolution
        .set('id', id)
        .set('isCancel', isCancel)
        .set('addedOptions', newlyAddedOptions)
        .set('removedOptions', newlyRemovedOptions)
        .set('resolutionActionOptions', actionOptions)
        .set('isExteriorColour', !isEmpty(exteriorColourOptions))
        .set('availableExteriorColours', availableExteriorColours)
        .set('isInteriorColour', !isEmpty(interiorColourOptions))
        .set('availableInteriorColours', availableInteriorColours);
}

export default {
    resetResolutionOptionsFromResolutionData,
};



// WEBPACK FOOTER //
// ../widget-commons-vehicle/src/ModelYear/services/OptionsSelectionResolutionService/OptionsSelectionResolutionService.js